import AlertPopup from "@/components/molecules/AlertPopup";
import { GlobalContext } from "@/contexts/SiteDataContext";
import dataLayer from "@/services/DataLayer";
import React, { useContext, useEffect } from "react";

const CLOSE_DATALAYER_KEY = "closePopupPassportNot5504";
const REDIRECT_DATALAYER_KEY = "redirectToD11FromPopupPassportNot5504";
const SHOWUP_DATALAYER_KEY = "showUpPopupPassportNot5504";

interface PassportNot5504AlertProps {
  onClose?: () => void;
}

const PassportNot5504Alert = ({ onClose }: PassportNot5504AlertProps) => {
  const { t } = useContext(GlobalContext).context;
  const handleOnClose = () => {
    dataLayer.push(CLOSE_DATALAYER_KEY);
    if (typeof onClose === "function") {
      onClose();
    }
  };

  const handleOnRedirect = () => {
    dataLayer.push(REDIRECT_DATALAYER_KEY);
  };

  useEffect(() => {
    dataLayer.push(SHOWUP_DATALAYER_KEY);
  }, []);

  return (
    <AlertPopup
      title={t["To renew or get a new passport you must select the correct form."]}
      alertMessage={
        t[
          "However, if you have entered the wrong information, correct your mistake and continue with your application."
        ]
      }
      onClose={handleOnClose}
      content={
        <>
          <div
            className="u-margin-bottom-s"
            dangerouslySetInnerHTML={{
              __html:
                t["<b>Remember:</b> You must answer Yes, to at least one of these questions:"],
            }}
          />
          <ul>
            <li className="u-list-bullet">
              {t["Have you changed your name since your most recent passport was issued?"]}
            </li>
            <li className="u-list-bullet">
              {t["Were your personal details printed incorrectly in your U.S. book or card?"]}
            </li>
            <li className="u-list-bullet">
              {t["Was your most recent passport book limited to two years?"]}
            </li>
          </ul>
        </>
      }
      redirect={{
        to: "/home",
        label: t["Select the correct form"],
        onClick: handleOnRedirect,
      }}
    />
  );
};

export default PassportNot5504Alert;
